import { SelectDataType } from "@sso/components/Form";

import { Organisation } from "./organisation";
import { SoftwareLicence } from "./softwareLicence";
import { BasicUserInfo } from "./user";

export enum LicenceSummaryKeys {
  LICENCE_ID = "licenceId",
  SOFTWARE_NAME = "softwareName",
  LICENCE_NAME = "licenceName",
  ORGANISATION_NAME = "organisationName",
  TYPE = "type",
  CONCURRENT_USERS_OR_USERNAME = "concurrentUsersOrUsername",
  EXPIRY_DATE = "expiryDate",
  TYPE_NAME = "typeName",
  EXPIRY_DATE_LABEL = "expiryDateLabel",
  ADDITIONAL_DATA = "additionalData",
  CREATE_DATE = "createDate",
  UPDATE_DATE = "updateDate",
  CREATE_DATE_LABEL = "createDateLabel",
  UPDATE_DATE_LABEL = "updateDateLabel",
}

export interface LicenceSummary {
  [LicenceSummaryKeys.LICENCE_ID]: string;
  [LicenceSummaryKeys.SOFTWARE_NAME]: string;
  [LicenceSummaryKeys.LICENCE_NAME]: string;
  [LicenceSummaryKeys.ORGANISATION_NAME]: string;
  [LicenceSummaryKeys.TYPE]: LicenceType;
  [LicenceSummaryKeys.CONCURRENT_USERS_OR_USERNAME]: string;
  [LicenceSummaryKeys.EXPIRY_DATE]: Date;
  [LicenceSummaryKeys.TYPE_NAME]: string;
  [LicenceSummaryKeys.EXPIRY_DATE_LABEL]: string;
  [LicenceSummaryKeys.ADDITIONAL_DATA]?: any;
  [LicenceSummaryKeys.CREATE_DATE]: Date;
  [LicenceSummaryKeys.UPDATE_DATE]: Date;
  [LicenceSummaryKeys.CREATE_DATE_LABEL]: string;
  [LicenceSummaryKeys.UPDATE_DATE_LABEL]: string;
}

export enum LicenceType {
  CONCURRENT = "Concurrent",
  SINGLE_USER = "SingleUser",
  TRIAL = "Trial",
  API = "API",
}

export const licenceTypeOption: SelectDataType[] = [
  { key: LicenceType.TRIAL, value: LicenceType.TRIAL, label: "Trial" },
  { key: LicenceType.SINGLE_USER, value: LicenceType.SINGLE_USER, label: "Single User" },
  { key: LicenceType.CONCURRENT, value: LicenceType.CONCURRENT, label: "Concurrent" },
  { key: LicenceType.API, value: LicenceType.API, label: "API" },
];

export const enum LicenceKeys {
  LICENCE_ID = "licenceId",
  SOFTWARE_ID = "softwareId",
  SOFTWARE = "software",
  SOFTWARE_LICENCE_ID = "softwareLicenceId",
  SOFTWARE_LICENCE = "softwareLicence",
  USER_ID = "userId",
  USER = "user",
  ORGANISATION_ID = "organisationId",
  ORGANISATION = "organisation",
  EXPIRY_DATE = "expiryDate",
  TYPE = "type",
  CONCURRENT_USERS = "concurrentUsers",
  NEVER_EXPIRE = "neverExpire",
  ADDITIONAL_DATA = "additionalData",
  ADDITIONAL_DATA_KEYS = "additionalDataKeys",
  TRACC_HARDWARE_ID = "Tracc_HardwareId",
  TRACC_SERVER_ADDRESS = "Tracc_ServerAddress",
  TRACC_DESCRIPTION = "Tracc_Description",
  ADDITIONAL_DATA_TYPE = "additionalDataType",
}

export interface LicenceFormType {
  [LicenceKeys.LICENCE_ID]?: string;
  [LicenceKeys.SOFTWARE_ID]?: string;
  [LicenceKeys.SOFTWARE_LICENCE_ID]?: string;
  [LicenceKeys.USER_ID]?: string;
  [LicenceKeys.ORGANISATION_ID]?: number;
  [LicenceKeys.EXPIRY_DATE]?: string;
  [LicenceKeys.TYPE]?: LicenceType;
  [LicenceKeys.CONCURRENT_USERS]?: number | null;
  [LicenceKeys.NEVER_EXPIRE]?: boolean;
  [LicenceKeys.TRACC_DESCRIPTION]?: string;
  [LicenceKeys.TRACC_HARDWARE_ID]?: string;
  [LicenceKeys.TRACC_SERVER_ADDRESS]?: string;
  [LicenceKeys.ADDITIONAL_DATA]?: any;
}

export interface Licence {
  [LicenceKeys.LICENCE_ID]: string;
  [LicenceKeys.SOFTWARE_LICENCE]: SoftwareLicence;
  [LicenceKeys.USER]: BasicUserInfo;
  [LicenceKeys.EXPIRY_DATE]?: string;
  [LicenceKeys.TYPE]: LicenceType;
  [LicenceKeys.CONCURRENT_USERS]?: number;
  [LicenceKeys.ORGANISATION]: Organisation;
  [LicenceKeys.ADDITIONAL_DATA]?: any;
}

export interface AssignTrialLicenceResponse {
  token: string;
  refreshToken: string;
}

export enum TraccLicenceSubType {
  SINGLE,
  CONCURRENT,
}
